import { render, staticRenderFns } from "./mainsuggestview.vue?vue&type=template&id=24b1120f&scoped=true&"
import script from "./mainsuggestview.vue?vue&type=script&lang=js&"
export * from "./mainsuggestview.vue?vue&type=script&lang=js&"
import style0 from "./mainsuggestview.vue?vue&type=style&index=0&id=24b1120f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b1120f",
  null
  
)

export default component.exports